import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  withStyles,
} from '@material-ui/core'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import Auth from './Auth'
import {
  AuditLogButton,
  DistroListButton,
  DoNotCallButton,
  MessageTemplateButton,
  HomeButton,
  ReportingButton,
  NotificationButton,
} from './Buttons'
import { useState } from 'react'
import { useAuth } from '@praxis/component-auth'
import { func } from 'prop-types'

const StyledList = withStyles({})(List)

const StyledListItemText = withStyles({
  primary: {
    color: '#212121',
  },
})(ListItemText)

export const SideBarItems = (props) => {
  const { onClose } = props
  const auth = useAuth()
  const { isAuthorized, isAuthenticated } = auth
  const [openBCP, setOpenBCP] = useState(false)
  const [openCEEbackup, setOpenCEEbackup] = useState(false)
  const [openFMOCDC, setOpenFMOCDC] = useState(false)
  const [openHR, setOpenHR] = useState(false)
  const [openC3, setOpenC3] = useState(false)
  const [openRecall, setOpenRecall] = useState(false)
  const [openC3A, setOpenC3A] = useState(false)
  const [openDeveloper, setOpenDeveloper] = useState(false)
  const [openShipt, setOpenShipt] = useState(false)

  const handleBCPClick = () => {
    setOpenBCP(!openBCP)
    setOpenCEEbackup(false)
    setOpenFMOCDC(false)
    setOpenHR(false)
    setOpenC3(false)
    setOpenRecall(false)
    setOpenC3A(false)
    setOpenDeveloper(false)
    setOpenShipt(false)
  }
  const handleCEEbackupClick = () => {
    setOpenBCP(false)
    setOpenCEEbackup(!openCEEbackup)
    setOpenFMOCDC(false)
    setOpenHR(false)
    setOpenC3(false)
    setOpenRecall(false)
    setOpenC3A(false)
    setOpenDeveloper(false)
    setOpenShipt(false)
  }
  const handleFMOCDCClick = () => {
    setOpenBCP(false)
    setOpenCEEbackup(false)
    setOpenFMOCDC(!openFMOCDC)
    setOpenHR(false)
    setOpenC3(false)
    setOpenRecall(false)
    setOpenC3A(false)
    setOpenDeveloper(false)
    setOpenShipt(false)
  }
  const handleHRClick = () => {
    setOpenBCP(false)
    setOpenCEEbackup(false)
    setOpenFMOCDC(false)
    setOpenHR(!openHR)
    setOpenC3(false)
    setOpenRecall(false)
    setOpenC3A(false)
    setOpenDeveloper(false)
    setOpenShipt(false)
  }
  const handleC3Click = () => {
    setOpenBCP(false)
    setOpenCEEbackup(false)
    setOpenFMOCDC(false)
    setOpenHR(false)
    setOpenC3(!openC3)
    setOpenRecall(false)
    setOpenC3A(false)
    setOpenDeveloper(false)
    setOpenShipt(false)
  }
  const handleRecallClick = () => {
    setOpenBCP(false)
    setOpenCEEbackup(false)
    setOpenFMOCDC(false)
    setOpenHR(false)
    setOpenC3(false)
    setOpenRecall(!openRecall)
    setOpenC3A(false)
    setOpenDeveloper(false)
    setOpenShipt(false)
  }
  const handleC3AClick = () => {
    setOpenBCP(false)
    setOpenCEEbackup(false)
    setOpenFMOCDC(false)
    setOpenHR(false)
    setOpenC3(false)
    setOpenRecall(false)
    setOpenC3A(!openC3A)
    setOpenDeveloper(false)
  }
  const handleDeveloperClick = () => {
    setOpenBCP(false)
    setOpenCEEbackup(false)
    setOpenFMOCDC(false)
    setOpenHR(false)
    setOpenC3(false)
    setOpenRecall(false)
    setOpenC3A(false)
    setOpenDeveloper(!openDeveloper)
  }
  const handleShiptClick = () => {
    setOpenBCP(false)
    setOpenCEEbackup(false)
    setOpenFMOCDC(false)
    setOpenHR(false)
    setOpenC3(false)
    setOpenRecall(false)
    setOpenC3A(false)
    setOpenDeveloper(false)
    setOpenShipt(!openShipt)
  }

  return (
    <div>
      <Auth />
      <StyledList disablePadding={true}>
        <HomeButton onClose={onClose} />
        {isAuthenticated() &&
          isAuthorized([
            'APP-OAUTH2-TOM-BCP',
            'APP-OAUTH2-TOM-BCP-Reporting',
          ]) && (
            <>
              <ListItem button onClick={handleBCPClick}>
                <ListItemIcon>
                  {openBCP ? <ExpandLess /> : <ExpandMore />}
                </ListItemIcon>
                <StyledListItemText primary="BCP" />
              </ListItem>
              <Collapse in={openBCP} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <NotificationButton
                    text="Start Notification"
                    to="/bcp_crisis_notification"
                    groups={['APP-OAUTH2-TOM-BCP']}
                    onClose={onClose}
                  />
                  <NotificationButton
                    text="Notify By TM Number"
                    to="/bcp_custom_notification"
                    groups={['APP-OAUTH2-TOM-BCP']}
                    onClose={onClose}
                  />
                  <AuditLogButton
                    text="View Audit Logs"
                    to="/bcp_auditlog"
                    groups={['APP-OAUTH2-TOM-BCP']}
                    onClose={onClose}
                  />
                  <ReportingButton
                    text="Reporting"
                    to="/bcp_crisis_reporting"
                    groups={[
                      'APP-OAUTH2-TOM-BCP-Reporting',
                      'APP-OAUTH2-TOM-BCP',
                    ]}
                    onClose={onClose}
                  />
                  <DistroListButton
                    text="Distribution Lists"
                    to="/bcp_distribution_list_maintenance"
                    groups={['APP-OAUTH2-TOM-BCP']}
                    onClose={onClose}
                  />
                  <MessageTemplateButton
                    text="Message Templates"
                    to="/bcp_message_template_maintenance"
                    groups={['APP-OAUTH2-TOM-BCP']}
                    onClose={onClose}
                  />
                  <DoNotCallButton
                    text="Do Not Call"
                    to="/bcp_donotcall"
                    groups={['APP-OAUTH2-TOM-BCP']}
                    onClose={onClose}
                  />
                </List>
              </Collapse>
            </>
          )}
        {isAuthenticated() &&
          isAuthorized([
            'APP-OAUTH2-TOM-CEEbackup',
            'APP-OAUTH2-TOM-CEEbackup-Reporting',
          ]) && (
            <>
              <ListItem button onClick={handleCEEbackupClick}>
                <ListItemIcon>
                  {openCEEbackup ? <ExpandLess /> : <ExpandMore />}
                </ListItemIcon>
                <StyledListItemText primary="CEE Backup" />
              </ListItem>
              <Collapse in={openCEEbackup} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <NotificationButton
                    text="Start Notification"
                    to="/ceebackup_crisis_notification"
                    groups={['APP-OAUTH2-TOM-CEEbackup']}
                    onClose={onClose}
                  />
                  <AuditLogButton
                    text="View Audit Logs"
                    to="/ceebackup_auditlog"
                    groups={['APP-OAUTH2-TOM-CEEbackup']}
                    onClose={onClose}
                  />
                  <ReportingButton
                    text="Reporting"
                    to="/ceebackup_crisis_reporting"
                    groups={[
                      'APP-OAUTH2-TOM-CEEbackup-Reporting',
                      'APP-OAUTH2-TOM-CEEbackup',
                    ]}
                    onClose={onClose}
                  />
                  <DistroListButton
                    text="Distribution Lists"
                    to="/ceebackup_distribution_list_maintenance"
                    groups={['APP-OAUTH2-TOM-CEEbackup']}
                    onClose={onClose}
                  />
                  <MessageTemplateButton
                    text="Message Templates"
                    to="/ceebackup_message_template_maintenance"
                    groups={['APP-OAUTH2-TOM-CEEbackup']}
                    onClose={onClose}
                  />
                  <DoNotCallButton
                    text="Do Not Call"
                    to="/ceebackup_donotcall"
                    groups={['APP-OAUTH2-TOM-CEEbackup']}
                    onClose={onClose}
                  />
                </List>
              </Collapse>
            </>
          )}
        {isAuthenticated() &&
          isAuthorized([
            'APP-OAUTH2-TOM-FMOCDC',
            'APP-OAUTH2-TOM-FMOCDC-Reporting',
          ]) && (
            <>
              <ListItem button onClick={handleFMOCDCClick}>
                <ListItemIcon>
                  {openFMOCDC ? <ExpandLess /> : <ExpandMore />}
                </ListItemIcon>
                <StyledListItemText primary="FMOC DC" />
              </ListItem>
              <Collapse in={openFMOCDC} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <NotificationButton
                    text="Start Notification"
                    to="/fmocdc_crisis_notification"
                    groups={['APP-OAUTH2-TOM-FMOCDC']}
                    onClose={onClose}
                  />
                  <AuditLogButton
                    text="View Audit Logs"
                    to="/fmocdc_auditlog"
                    groups={['APP-OAUTH2-TOM-FMOCDC']}
                    onClose={onClose}
                  />
                  <ReportingButton
                    text="Reporting"
                    to="/fmocdc_crisis_reporting"
                    groups={[
                      'APP-OAUTH2-TOM-FMOCDC-Reporting',
                      'APP-OAUTH2-TOM-FMOCDC',
                    ]}
                    onClose={onClose}
                  />
                  <DistroListButton
                    text="Distribution Lists"
                    to="/fmocdc_distribution_list_maintenance"
                    groups={['APP-OAUTH2-TOM-FMOCDC']}
                    onClose={onClose}
                  />
                  <MessageTemplateButton
                    text="Message Templates"
                    to="/fmocdc_message_template_maintenance"
                    groups={['APP-OAUTH2-TOM-FMOCDC']}
                    onClose={onClose}
                  />
                  <DoNotCallButton
                    text="Do Not Call"
                    to="/fmocdc_donotcall"
                    groups={['APP-OAUTH2-TOM-FMOCDC']}
                    onClose={onClose}
                  />
                </List>
              </Collapse>
            </>
          )}
        {isAuthenticated() &&
          isAuthorized([
            'APP-OAUTH2-TOM-StoreHR',
            'APP-OAUTH2-TOM-StoreHR-Reporting',
          ]) && (
            <>
              <ListItem button onClick={handleHRClick}>
                <ListItemIcon>
                  {openHR ? <ExpandLess /> : <ExpandMore />}
                </ListItemIcon>
                <StyledListItemText primary="Stores HR" />
              </ListItem>
              <Collapse in={openHR} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <NotificationButton
                    text="Start Notification"
                    to="/hr_crisis_notification"
                    groups={['APP-OAUTH2-TOM-StoreHR']}
                    onClose={onClose}
                  />
                  <NotificationButton
                    text="Notify By TM Number"
                    to="/hr_crisis_custom_notification"
                    groups={['APP-OAUTH2-TOM-StoreHR']}
                    onClose={onClose}
                  />
                  <AuditLogButton
                    text="View Audit Logs"
                    to="/hr_auditlog"
                    groups={['APP-OAUTH2-TOM-StoreHR']}
                    onClose={onClose}
                  />
                  <ReportingButton
                    text="Reporting"
                    to="/hr_crisis_reporting"
                    groups={[
                      'APP-OAUTH2-TOM-StoreHR-Reporting',
                      'APP-OAUTH2-TOM-StoreHR',
                    ]}
                    onClose={onClose}
                  />
                  <DistroListButton
                    text="Distribution Lists"
                    to="/hr_distribution_list_maintenance"
                    groups={['APP-OAUTH2-TOM-StoreHR']}
                    onClose={onClose}
                  />
                  <MessageTemplateButton
                    text="Message Templates"
                    to="/hr_message_template_maintenance"
                    groups={['APP-OAUTH2-TOM-StoreHR']}
                    onClose={onClose}
                  />
                  <DoNotCallButton
                    text="Do Not Call"
                    to="/hr_donotcall"
                    groups={['APP-OAUTH2-TOM-StoreHR']}
                    onClose={onClose}
                  />
                </List>
              </Collapse>
            </>
          )}
        {isAuthenticated() &&
          isAuthorized([
            'APP-OAUTH2-TOM-C3',
            'APP-OAUTH2-TOM-C3-Reporting',
          ]) && (
            <>
              <ListItem button onClick={handleC3Click}>
                <ListItemIcon>
                  {openC3 ? <ExpandLess /> : <ExpandMore />}
                </ListItemIcon>
                <StyledListItemText primary="C3" />
              </ListItem>
              <Collapse in={openC3} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <NotificationButton
                    text="Start Notification"
                    to="/c3_crisis_notification"
                    groups={['APP-OAUTH2-TOM-C3']}
                    onClose={onClose}
                  />
                  <NotificationButton
                    text="Notify By TM Number"
                    to="/c3_custom_notification"
                    groups={['APP-OAUTH2-TOM-C3']}
                    onClose={onClose}
                  />
                  <AuditLogButton
                    text="View Audit Logs"
                    to="/c3_auditlog"
                    groups={['APP-OAUTH2-TOM-C3']}
                    onClose={onClose}
                  />
                  <ReportingButton
                    text="Reporting"
                    to="/c3_crisis_reporting"
                    groups={[
                      'APP-OAUTH2-TOM-C3-Reporting',
                      'APP-OAUTH2-TOM-C3',
                    ]}
                    onClose={onClose}
                  />
                  <DistroListButton
                    text="Distribution Lists"
                    to="/c3_distribution_list_maintenance"
                    groups={['APP-OAUTH2-TOM-C3']}
                    onClose={onClose}
                  />
                  <MessageTemplateButton
                    text="Message Templates"
                    to="/c3_message_template_maintenance"
                    groups={['APP-OAUTH2-TOM-C3']}
                    onClose={onClose}
                  />
                  <DoNotCallButton
                    text="Do Not Call"
                    to="/c3_donotcall"
                    groups={['APP-OAUTH2-TOM-C3']}
                    onClose={onClose}
                  />
                </List>
              </Collapse>
            </>
          )}
        {isAuthenticated() &&
          isAuthorized([
            'APP-OAUTH2-TOM-Recall',
            'APP-OAUTH2-TOM-Recall-Reporting',
          ]) && (
            <>
              <ListItem button onClick={handleRecallClick}>
                <ListItemIcon>
                  {openRecall ? <ExpandLess /> : <ExpandMore />}
                </ListItemIcon>
                <StyledListItemText primary="Product Recall" />
              </ListItem>
              <Collapse in={openRecall} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <NotificationButton
                    text="Start Notification"
                    to="/recall_crisis_notification"
                    groups={['APP-OAUTH2-TOM-Recall']}
                    onClose={onClose}
                  />
                  <NotificationButton
                    text="Notify By TM Number"
                    to="/recall_custom_notification"
                    groups={['APP-OAUTH2-TOM-Recall']}
                    onClose={onClose}
                  />
                  <AuditLogButton
                    text="View Audit Logs"
                    to="/recall_auditlog"
                    groups={['APP-OAUTH2-TOM-Recall']}
                    onClose={onClose}
                  />
                  <ReportingButton
                    text="Reporting"
                    to="/recall_crisis_reporting"
                    groups={[
                      'APP-OAUTH2-TOM-Recall-Reporting',
                      'APP-OAUTH2-TOM-Recall',
                    ]}
                    onClose={onClose}
                  />
                  <DistroListButton
                    text="Distribution Lists"
                    to="/recall_distribution_list_maintenance"
                    groups={['APP-OAUTH2-TOM-Recall']}
                    onClose={onClose}
                  />
                  <MessageTemplateButton
                    text="Message Templates"
                    to="/recall_message_template_maintenance"
                    groups={['APP-OAUTH2-TOM-Recall']}
                    onClose={onClose}
                  />
                  <DoNotCallButton
                    text="Do Not Call"
                    to="/recall_donotcall"
                    groups={['APP-OAUTH2-TOM-Recall']}
                    onClose={onClose}
                  />
                </List>
              </Collapse>
            </>
          )}
        {isAuthenticated() &&
          isAuthorized([
            'APP-OAUTH2-TOM-C3A',
            'APP-OAUTH2-TOM-C3A-Reporting',
          ]) && (
            <>
              <ListItem button onClick={handleC3AClick}>
                <ListItemIcon>
                  {openC3A ? <ExpandLess /> : <ExpandMore />}
                </ListItemIcon>
                <StyledListItemText primary="C3A" />
              </ListItem>
              <Collapse in={openC3A} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <NotificationButton
                    text="Start Notification"
                    to="/c3a_crisis_notification"
                    groups={['APP-OAUTH2-TOM-C3A']}
                    onClose={onClose}
                  />
                  <NotificationButton
                    text="Notify By TM Number"
                    to="/c3a_custom_notification"
                    groups={['APP-OAUTH2-TOM-C3A']}
                    onClose={onClose}
                  />
                  <AuditLogButton
                    text="View Audit Logs"
                    to="/c3a_auditlog"
                    groups={['APP-OAUTH2-TOM-C3A']}
                    onClose={onClose}
                  />
                  <ReportingButton
                    text="Reporting"
                    to="/c3a_crisis_reporting"
                    groups={[
                      'APP-OAUTH2-TOM-C3A-Reporting',
                      'APP-OAUTH2-TOM-C3A',
                    ]}
                    onClose={onClose}
                  />
                  <DistroListButton
                    text="Distribution Lists"
                    to="/c3a_distribution_list_maintenance"
                    groups={['APP-OAUTH2-TOM-C3A']}
                    onClose={onClose}
                  />
                  <MessageTemplateButton
                    text="Message Templates"
                    to="/c3a_message_template_maintenance"
                    groups={['APP-OAUTH2-TOM-C3A']}
                    onClose={onClose}
                  />
                  <DoNotCallButton
                    text="Do Not Call"
                    to="/c3a_donotcall"
                    groups={['APP-OAUTH2-TOM-C3A']}
                    onClose={onClose}
                  />
                </List>
              </Collapse>
            </>
          )}
        {isAuthenticated() &&
          isAuthorized([
            'APP-OAUTH2-NS-VSAPIDeveloper-NP',
            'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
            'APP-OAUTH2-TOM-Developer',
          ]) && (
            <>
              <ListItem button onClick={handleDeveloperClick}>
                <ListItemIcon>
                  {openDeveloper ? <ExpandLess /> : <ExpandMore />}
                </ListItemIcon>
                <StyledListItemText primary="Developer" />
              </ListItem>
              <Collapse in={openDeveloper} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <NotificationButton
                    text="Start Notification"
                    to="/developer_notification"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                    ]}
                    onClose={onClose}
                  />
                  <NotificationButton
                    text="Notify By TM Number"
                    to="/developer_custom_notification"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                    ]}
                    onClose={onClose}
                  />
                  <AuditLogButton
                    text="View Audit Logs"
                    to="/developer_auditlog"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                    ]}
                    onClose={onClose}
                  />
                  <ReportingButton
                    text="Reporting"
                    to="/developer_reporting"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                    ]}
                    onClose={onClose}
                  />
                  <DistroListButton
                    text="Distribution Lists"
                    to="/developer_distribution_list_maintenance"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                    ]}
                    onClose={onClose}
                  />
                  <MessageTemplateButton
                    text="Message Templates"
                    to="/developer_message_template_maintenance"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                    ]}
                    onClose={onClose}
                  />
                  <DoNotCallButton
                    text="Do Not Call"
                    to="/developer_donotcall"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                    ]}
                    onClose={onClose}
                  />
                </List>
              </Collapse>
            </>
          )}
        {isAuthenticated() &&
          isAuthorized([
            'APP-OAUTH2-NS-VSAPIDeveloper-NP',
            'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
            'APP-OAUTH2-TOM-Developer',
            'APP-OAUTH2-TOM-Shipt',
            'APP-OAUTH2-TOM-Shipt-Reporting',
          ]) && (
            <>
              <ListItem button onClick={handleShiptClick}>
                <ListItemIcon>
                  {openShipt ? <ExpandLess /> : <ExpandMore />}
                </ListItemIcon>
                <StyledListItemText primary="Shipt" />
              </ListItem>
              <Collapse in={openShipt} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <NotificationButton
                    text="Start Notification"
                    to="/shipt_notification"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                      'APP-OAUTH2-TOM-Shipt',
                      'APP-OAUTH2-TOM-Shipt-Reporting',
                    ]}
                    onClose={onClose}
                  />
                  <NotificationButton
                    text="Notify By TM Number"
                    to="/shipt_custom_notification"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                      'APP-OAUTH2-TOM-Shipt',
                      'APP-OAUTH2-TOM-Shipt-Reporting',
                    ]}
                    onClose={onClose}
                  />
                  <AuditLogButton
                    text="View Audit Logs"
                    to="/shipt_auditlog"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                      'APP-OAUTH2-TOM-Shipt',
                      'APP-OAUTH2-TOM-Shipt-Reporting',
                    ]}
                    onClose={onClose}
                  />
                  <ReportingButton
                    text="Reporting"
                    to="/shipt_reporting"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                      'APP-OAUTH2-TOM-Shipt',
                      'APP-OAUTH2-TOM-Shipt-Reporting',
                    ]}
                    onClose={onClose}
                  />
                  <DistroListButton
                    text="Distribution Lists"
                    to="/shipt_distribution_list_maintenance"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                      'APP-OAUTH2-TOM-Shipt',
                      'APP-OAUTH2-TOM-Shipt-Reporting',
                    ]}
                    onClose={onClose}
                  />
                  <MessageTemplateButton
                    text="Message Templates"
                    to="/shipt_message_template_maintenance"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                      'APP-OAUTH2-TOM-Shipt',
                      'APP-OAUTH2-TOM-Shipt-Reporting',
                    ]}
                    onClose={onClose}
                  />
                  <DoNotCallButton
                    text="Do Not Call"
                    to="/shipt_donotcall"
                    groups={[
                      'APP-OAUTH2-NS-VSAPIDeveloper-NP',
                      'APP-OAUTH2-NS-VSAPIDeveloper-PRD',
                      'APP-OAUTH2-TOM-Developer',
                      'APP-OAUTH2-TOM-Shipt',
                      'APP-OAUTH2-TOM-Shipt-Reporting',
                    ]}
                    onClose={onClose}
                  />
                </List>
              </Collapse>
            </>
          )}
      </StyledList>
    </div>
  )
}

SideBarItems.propTypes = {
  onClose: func.isRequired,
}
